/** Verification pages never load analytics; their embedded forms also carry `ph-no-capture`.
 *  The start-up script (`lib/early-analytics/bootstrap.ts`) checks the same path inline. */
export function isAnalyticsFreePath(pathname: string): boolean {
  return /^\/auth\/[^/]+\/verify\/*$/.test(pathname);
}
